import { List } from 'core/common/ui/ui-kit';
import { ReviewCard } from 'core/common/ui/widgets';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { SectionFeedbackCardsAttributes } from 'core/flow/entities';
import { TitleStyled } from './styled';

type FeedbackCardsProps = {
  content: SectionFeedbackCardsAttributes['content'];
};

export const FeedbackCards = ({ content }: FeedbackCardsProps) => {
  return (
    <>
      <TitleStyled variant="h1" dangerouslySetInnerHTML={prepareHtml(content.title)} />
      <List spacing={4}>
        {content.list.map(({ date, review, userName, verified }, index) => (
          <ReviewCard
            key={userName + index}
            date={date}
            review={review}
            userName={userName}
            verified={verified}
          />
        ))}
      </List>
    </>
  );
};
